//CRN_20260508 - Riskline Pre-Travel Advisories service (PUSH side - reads from SureSim backend)
//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { catchError, Observable, of, throwError } from 'rxjs';
import { eSimApiPaths } from '../../consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../utelize/general/exceptions-service';
import { HttpClientService } from '../utelize/general/http-client-service';
import { Injectable } from '@angular/core';
import { PtaDTO } from '../../models/system/riskline/riskline-pta.dto';

@Injectable({ providedIn: 'root' })
export class RisklinePtasService {

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getAllPtas(language?: string): Observable<PtaDTO[]> {
    try {
      const qs=(language && language.trim()!='') ? ('?language=' + encodeURIComponent(language)) : '';

      return this.httpClientService
             .get<PtaDTO[]>(environment.eSimApi +
                            eSimApiPaths.RiskIntelligence + '/' +
                            eSimApiPaths.RiskIntelligencePtas +
                            qs)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklinePtasService.getAllPtas() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of([]);
    }
  }

  public getPtaForCountry(isoCode: string, language?: string): Observable<PtaDTO> {
    try {
      if (!isoCode || isoCode.trim()=='')
        throw new Error('RisklinePtasService.getPtaForCountry() - isoCode is required');

      const qs=(language && language.trim()!='') ? ('?language=' + encodeURIComponent(language)) : '';

      return this.httpClientService
             .get<PtaDTO>(environment.eSimApi +
                          eSimApiPaths.RiskIntelligence + '/' +
                          eSimApiPaths.RiskIntelligencePtas + '/' +
                          isoCode +
                          qs)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklinePtasService.getPtaForCountry() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
